import { Injectable } from "@angular/core";
import { IPlot } from "@app/interfaces/IPlot";
import { PlotService } from "@app/services/plots/plot.service";
import { lastValueFrom } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class VehicleStatusService {
    private latestPlots = new Map<number, IPlot>();
    constructor(private readonly plotService: PlotService) {
        this.getLatestPlots();
    }

    async getLatestPlotForVehicle(vehicleId: number): Promise<IPlot> {
        if (!this.latestPlots.size) {
            await this.getLatestPlots();
        }

        return this.latestPlots.get(vehicleId);
    }

    private async getLatestPlots(): Promise<void> {
        await lastValueFrom(this.plotService.getLatestPlots().pipe(tap(
            plots => {
                this.latestPlots = new Map(plots.map(plot => [plot.VehicleId, plot]));
            }
        )))
    }
}
